import BillingsOrderRelatedTaxiRailyResponse, {
  BillingsOrderRelatedTaxiRailyResponseDate,
  BillingsOrderRelatedTaxiRailyResponseDataCargoOrder,
  BillingsOrderRelatedTaxiRailyResponseDataContract,
  BillingsOrderRelatedTaxiRailyResponseDataContractCargoCompany,
} from "../../../../../api/raily/billings/order/related/taxi-raily/billings-order-related-taxi-raily.response";
import BillingsOrderRelatedTaxiRailyItem, {
  BillingsOrderRelatedTaxiRailyCargoOrder,
  BillingsOrderRelatedTaxiRailyContract,
  BillingsOrderRelatedTaxiRailyContractCargoCompany,
} from "./billings-order-related-taxi-raily";

const createCargoOrder = (
  cargoOrder: BillingsOrderRelatedTaxiRailyResponseDataCargoOrder,
): BillingsOrderRelatedTaxiRailyCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    uuid: cargoOrder.id,
  };
};

const createCargoCompany = (
  cargoCompany: BillingsOrderRelatedTaxiRailyResponseDataContractCargoCompany,
): BillingsOrderRelatedTaxiRailyContractCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createContract = (
  contract: BillingsOrderRelatedTaxiRailyResponseDataContract,
): BillingsOrderRelatedTaxiRailyContract => {
  return {
    cargoCompany: createCargoCompany(contract.cargoCompany),
    distanceRate: contract.distanceRate,
    model: contract.model,
  };
};

const createItem = (
  item: BillingsOrderRelatedTaxiRailyResponseDate,
): BillingsOrderRelatedTaxiRailyItem => {
  return {
    cargoOrder: createCargoOrder(item.cargoOrder),
    contract: createContract(item.contract),
    date: item.date,
    discount: item.discount,
    discountAmount: item.discountAmount,
    distance: item.distance,
    haltingAmount: item.haltingAmount,
    highwayCharge: item.highwayCharge,
    totalAmount: item.totalAmount,
  };
};

const createItems = (
  items: BillingsOrderRelatedTaxiRailyResponseDate[],
): BillingsOrderRelatedTaxiRailyItem[] => {
  return items.map(createItem);
};

const create = (
  response: BillingsOrderRelatedTaxiRailyResponse,
): BillingsOrderRelatedTaxiRailyItem[] => {
  return createItems(response.data);
};

const billingsOrderRelatedTaxiRailyFactory = {
  create,
};

export default billingsOrderRelatedTaxiRailyFactory;
